import cardMockSrc from '../../assets/images/card_mock.png';

import { ArtCategoryCard } from "../../components/ArtCategoryCard";
import { HomeBanner } from "../../components/Banners/HomeBanner";
import { MoreBanner } from '../../components/Banners/MoreBanner';
import { Footer } from "../../components/Footer";
import { Header } from "../../components/Header";

import styles from './styles.module.css';

const artistsMock = [
    {
        name: "Vincent van Gogh",
        href: "artists/1"
    },
    {
        name: "Vincent van Gogh",
        href: "artists/1"
    },
    {
        name: "Vincent van Gogh",
        href: "artists/1"
    }
]

// TODO: удалить моки, парсить информацию с бекенда

export const Home = () => {
    return (
        <div>
            <Header />
            <HomeBanner />
            <div className={styles.artCategoriesContainer}>
                {[1,2,3].map(() => {
                    return (
                        <ArtCategoryCard title="Old masters" artists={artistsMock} imageSrc={cardMockSrc}/>
                    )
                })}
            </div>
            <MoreBanner className={styles.moreBanner}/>
            <Footer />
        </div>
    );
}